import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { JsonObject } from 'json2typescript';

@JsonObject('KovanExtendingModel')
export class KovanExtendingModel extends HvlBaseModel {}
